import { useNavigate } from "react-router-dom";
import "./factsheet.css";

const FactSheetCard = ({ img, heading }: any) => {
  const navigate = useNavigate();
  return (
    <div className="fsc-cnt">
      <div className="fsc-img-cnt">
        <img src={img} alt="" className="fsc-img" />
      </div>
      <div className="fsc-text-cnt">
        <p className="fsc-heading">{heading}</p>
        <div
          className="fsc-btn"
          onClick={() => {
            navigate(`/insights/factsheet/download`);
          }}
        >
          Download
        </div>
      </div>
    </div>
  );
};

export default FactSheetCard;
